import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../components/Breadcrumbs";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../constant";
import { Toast } from "primereact/toast";
import validator from 'validator';
import { Message } from "@mui/icons-material";


function ContactUs() {

    const [show, setShow] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const messagelength = useRef("");
    const { t, i18n } = useTranslation();
    const toast = useRef(null);

    const showError = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Message d\'erreur', detail: msg, life: 3000 });
    }
    const showSuccess = (msg) => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: msg, life: 3000 });
    }
    const sendData = () => {
        if (firstName !== "" && lastName !== "" && validator.isEmail(email) && subject !== "" && message !== "") {
            axios.post(`${API_BASE_URL}api/contacts`, {
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                Subject: subject,
                Message: message,
            })
                .then(function (response) {
                    showSuccess("Votre message a été envoyé");
                })
                .catch(function (error) {
                    showError(error.response.data.errorMessage);
                });
        } else {
            showError("Vous devez remplir tous les champs");
        }

    }
    return (
        <div className="w-screen">
            <Toast ref={toast} />
            {i18n.language === "fr" ? (
                <Breadcrumbs>
                    <Link to="/">{t('navbar.home')}</Link>
                    <Link to="/contact">{t('contact.title')}</Link>
                    {/*<span>{name}</span>*/}
                </Breadcrumbs>
            ) : (
                <Breadcrumbs>
                    <Link to="/contact">{t('navbar.contact')}</Link>
                    <Link to="/">{t('navbar.home')}</Link>
                    {/*<span>{name}</span>*/}
                </Breadcrumbs>
            )}
            <div className=" w-full flex items-center justify-center my-12">
                <div className=" top-40 bottom-40 bg-white shadow-2xl rounded py-12 lg:px-28 px-8">
                    <p className="md:text-3xl text-xl font-bold leading-7 text-center text-gray-700 mb-8">{t('contact.title')}</p>
                    <br />
                    <form className="mx-auto grid max-w-screen-md gap-4 sm:grid-cols-2 pt-4">
                        <div>
                            <label htmlFor="first-name"
                                className={`mb-2 inline-block font-semibold text-sm text-gray-700 sm:text-base ${i18n.language === 'fr' ? 'float-left' : 'float-right'}`}>{t('contact.firstName')}*</label>
                            <input name="first-name"
                                onChange={(e) => {
                                    setFirstName(e.target.value)
                                }}
                                required={true}
                                placeholder="First name"
                                className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-700 outline-none ring-indigo-300 transition duration-100 focus:ring" />
                        </div>

                        <div>
                            <label htmlFor="last-name" className={`mb-2 inline-block font-semibold text-sm text-gray-700 sm:text-base ${i18n.language === 'fr' ? 'float-left' : 'float-right'}`}>{t('contact.lastName')}*</label>
                            <input name="last-name"
                                placeholder="Last name"
                                required={true}
                                onChange={(e) => {
                                    setLastName(e.target.value)
                                }}
                                className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-700 outline-none ring-indigo-300 transition duration-100 focus:ring" />
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="email"
                                className={`mb-2 inline-block font-semibold text-sm text-gray-700 sm:text-base ${i18n.language === 'fr' ? 'float-left' : 'float-right'}`}>{t('contact.email')}*</label>
                            <input name="email"
                                type="email"
                                placeholder="Email"
                                required={true}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                }}
                                className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-700 outline-none ring-indigo-300 transition duration-100 focus:ring" />
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="subject"
                                className={`mb-2 inline-block font-semibold text-sm text-gray-700 sm:text-base ${i18n.language === 'fr' ? 'float-left' : 'float-right'}`}>{t('contact.subject')}*</label>
                            <input name="subject"
                                placeholder="Subject"
                                required={true}
                                onChange={(e) => {
                                    setSubject(e.target.value)
                                }}
                                className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-700 outline-none ring-indigo-300 transition duration-100 focus:ring" />
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="message"
                                className={`mb-2 inline-block text-sm font-semibold text-gray-700 sm:text-base ${i18n.language === 'fr' ? 'float-left' : 'float-right'}`}>{t('contact.message')}*</label>
                            <textarea name="message"
                                maxLength={500}
                                required={true}
                                onChange={(e) => {
                                    if (messagelength.current.length < 500) {
                                        setMessage(e.target.value);
                                        messagelength.current = e.target.value;
                                    }
                                }}
                                className="h-64 w-full rounded border bg-gray-50 px-3 py-2 text-gray-700 outline-none ring-indigo-300 transition duration-100 focus:ring"></textarea>
                        </div>

                        <div className="flex items-center justify-between sm:col-span-2">
                            <button
                                onClick={sendData}

                                className="inline-block rounded-lg bg-primary-color px-8 py-3 text-center text-sm font-semibold text-white outline-none ring-indigo-300 transition duration-100 hover:bg-secondary-color focus-visible:ring active:bg-indigo-700 md:text-base">
                                {t('contact.sendbtn')}
                            </button>

                            <span className="align-top h-12  text-sm text-gray-500">{messagelength.current.length}/500</span>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    );
}

export default ContactUs;